import API from './API';

export default class CurrencyRate extends API {
  constructor(parameters = {}) {
    super('/CurrencyRate', parameters);
  }

  getCurrencyRateCBR(data) {
    return this.submit("get", `${this.endpoint}/Get?date=${data.onDate}&currencyCode=${data.currencyCode}`);
  }

  getCurrencyRateImported(data) {
    return this.submit("get", `${this.endpoint}/Get?type=${data.type}&importedId=${data.importedId}&date=${data.onDate}&currencyCode=${data.currencyCode}`);
  }

  getCurrencyRateCorridor(data) {
    return this.submit("get",
      `${this.endpoint}/Get?type=${data.type}&date=${data.onDate}&currencyCode=${data.currencyCode}&minValue=${data.minValue}&maxValue=${data.maxValue}`
    );
  }

  getCurrencyRateCorridorImported(data) {
    return this.submit("get",
      `${this.endpoint}/Get?type=${data.type}&date=${data.onDate}&currencyCode=${data.currencyCode}&minValue=${data.minValue}&maxValue=${data.maxValue}`
    );
  }

  getCurrencyRateFixed(data) {
    return this.submit("get",
      `${this.endpoint}/Get?type=${data.type}&date=${data.onDate}&currencyCode=${data.currencyCode}&fixedValue=${data.fixedValue}`
    );
  }

  getCurrencyRateFromCBR(date, currencyCode) {
    return this.submit("get", `${this.endpoint}/FromCBR?date=${date}&currencyCode=${currencyCode}`);
  }
  getCurrencyRateFromImport(date, currencyCode, importedId) {
    return this.submit("get", `${this.endpoint}/FromImport?date=${date}&currencyCode=${currencyCode}&importedId=${importedId}`);
  }

  getImportedCourseNames() {
    return this.submit("get", `${this.endpoint}/ImportedFiles`);
  }
}
